import React, { useEffect } from 'react';
import { DesktopLanding } from '@modules/Landing/Components/DesktopLanding/DesktopLanding';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { MobileLanding } from '@modules/Landing/Components/MobileLanding/MobileLanding';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@configs/AppRoutes';
import { useUserInfoViewModel } from '@viewModels/UserInfoViewModel/UserInfoViewModel';

export const LandingPage: React.FC = () => {
    const [isDesktop, isTablet, isMobile] = useMediaType();
    const { bearerToken } = useAuthorizationViewModel();
    const { fetchMyProfileInfo, currentUser, isMyProfileInfoLoading } =
        useUserInfoViewModel();
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuthorization = async () => {
            if (isMyProfileInfoLoading) return;
            if (bearerToken) {
                await fetchMyProfileInfo();
                if (currentUser.projectsCount > 0) {
                    navigate(ROUTES.BOM);
                }
            }
        };

        checkAuthorization();
    }, [bearerToken]);

    return isDesktop ? <DesktopLanding /> : <MobileLanding />;
};

export default LandingPage;
